"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateColorAlpha = exports.argb2Rgba = exports.safeArgb2Rgba = void 0;
/**
 * @param argb
 * @param warningMessage pass `null` if you want the default error message
 * @returns
 */
function safeArgb2Rgba(argb, warningMessage) {
    try {
        return argb2Rgba(argb);
    }
    catch (error) {
        console.error(warningMessage || error);
        return '';
    }
}
exports.safeArgb2Rgba = safeArgb2Rgba;
/**
 * If you don't want an Error, please use `safeArgb2Rgba` instead
 */
function argb2Rgba(argb) {
    var error = 'argb2Rgba Error: input `argb` should be in format #FFFFFF or #FFFFFFFF, received: ' +
        argb;
    if (!argb) {
        throw new Error(error);
    }
    if (!argb.startsWith('#')) {
        throw new Error(error);
    }
    if (argb.length !== 7 && argb.length !== 9) {
        throw new Error(error);
    }
    var num = Number(argb.replace('#', '0x'));
    var b = num & 0xff, g = (num & 0xff00) >>> 8, r = (num & 0xff0000) >>> 16, a = argb.length === 7 ? 1 : ((num & 0xff000000) >>> 24) / 255;
    return 'rgba(' + [r, g, b, a].join(',') + ')';
}
exports.argb2Rgba = argb2Rgba;
function updateColorAlpha(color, alpha) {
    var error = 'updateColorAlpha Error: input `color` should be in format #FFFFFF, #FFFFFFFF, rgb(x,x,x) or rgba(x,x,x,x), received: ' +
        color +
        ',' +
        alpha;
    if (!color) {
        throw new Error(error);
    }
    if (!color.startsWith('#') && !color.startsWith('rgb')) {
        throw new Error(error);
    }
    if (color.startsWith('rgb') &&
        !color.replace(/\s/g, '').match(/^rgb\([.\d]+,[.\d]+,[.\d]+\)$/) &&
        !color.replace(/\s/g, '').match(/^rgba\([.\d]+,[.\d]+,[.\d]+,[.\d]+\)$/)) {
        throw new Error(error);
    }
    var rgba = color.startsWith('#')
        ? argb2Rgba(color)
        : color.replace(/\s/g, '');
    return rgba.replace(/rgba?\(([.\d]+,[.\d]+,[.\d]+)(,[.\d]+)?\)/, "rgba($1," + alpha + ")");
}
exports.updateColorAlpha = updateColorAlpha;
//# sourceMappingURL=colorUtil.js.map